import React from 'react';
import {get as _get} from 'lodash';
import moment from 'moment';

import {getStadiumOrVenueNameFromEvent} from '@utils/stadium';
import {getTvChannelNamesFromEvent} from '@utils/tvChannels';
import {renderEventStatusName} from '@utils/status';
import {getSportName, getTournamentCategoryName, getTournamentName} from '@modules/events/utils/eventSchedule';
import {getReportScopeLabel} from '@modules/events/utils/eventsReport';

import {CompetitorNameAndDescription, MatchId} from '../../views/common/CompetitorNameAndDescription';

const tableRowRenderer = (column, row) => {
    switch (column) {
        case 'start_datetime':
            return moment(row[column]).format('YYYY-MM-DD HH:mm');
        case 'id':
            return row.id;
        case 'match_id':
            return <MatchId event={row}/>;
        case 'sport_name':
            return getSportName(row);
        case 'category_name':
            return getTournamentCategoryName(row);
        case 'tournament_name':
            return getTournamentName(row);
        case 'venue_or_court_or_tvchannel': {
            const tvChannels = getTvChannelNamesFromEvent(row);

            return (
                <>
                    {getStadiumOrVenueNameFromEvent(row)}
                    {tvChannels && <p>{tvChannels}</p>}
                </>
            );
        }
        case 'competitors':
            return <CompetitorNameAndDescription event={row}/>;
        case 'status':
            return renderEventStatusName(row.event_status.id, row.event_status.name);
        case 'report_scope':
            return getReportScopeLabel(row, {excel: false});
        case 'notes':
            return _get(row, 'notes', '');
    }
};

export default tableRowRenderer;
